var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoUseplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 180,
    viewBox: "0 0 350 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 180,
    rx: 32,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.75 81.1001C104.15 81.1001 102.95 82.1001 102.95 83.5001C102.95 85.0001 104.35 85.9001 107.15 86.5001L109.65 87.1001C116.15 88.5001 118.95 91.6001 119.05 96.2001C119.05 102.1 114.45 105.4 106.85 105.4C99.05 105.4 94.05 102 93.95 94.6001H101.55C101.65 97.4001 103.65 98.9001 106.75 98.9001C109.45 98.9001 110.95 97.8001 110.95 96.2001C110.95 94.7001 109.75 93.9001 106.35 93.2001L103.35 92.5001C98.05 91.3001 94.85 88.7001 94.85 84.1001C94.85 78.4001 99.85 74.6001 106.85 74.6001C114.05 74.6001 118.65 78.5001 118.65 84.3001H111.05C110.85 82.2001 109.45 81.1001 106.75 81.1001Z",
    fill: "#F98F10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.35 74.8999H143.85V81.2999H130.25V86.7999H142.75V93.1999H130.25V98.5999H143.75V105H122.35V74.8999Z",
    fill: "#F98F10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.15 74.8999H159.95C166.65 74.8999 171.05 79.0999 171.05 85.4999C171.05 91.8999 166.55 95.9999 159.65 95.9999H154.95V105.1H147.05V74.8999H147.15ZM158.15 89.7999C161.15 89.7999 162.85 88.0999 162.85 85.4999C162.85 82.8999 161.15 81.2999 158.15 81.2999H155.05V89.7999H158.15Z",
    fill: "#F98F10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.45 74.8999H182.35V98.5999H194.65V105H174.45V74.8999Z",
    fill: "#F98F10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.95 105L207.95 74.8999H218.75L228.75 105H220.25L218.45 99.0999H208.35L206.55 105H197.95ZM216.55 93.0999L213.45 82.9999H213.25L210.15 93.0999H216.55Z",
    fill: "#F98F10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.75 81.4C242.55 81.4 240.25 84.6 240.25 90C240.25 95.7 242.65 98.6 246.75 98.6C249.75 98.6 251.75 96.9 252.15 94.3L260.15 94.4C259.75 99.6 255.25 105.5 246.55 105.5C238.25 105.5 232.05 100 232.05 90C232.05 80 238.45 74.5 246.55 74.5C254.05 74.5 259.45 78.7 260.15 86.1H252.15C251.85 83.3 249.95 81.4 246.75 81.4Z",
    fill: "#F98F10"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M263.45 74.8999H284.95V81.2999H271.35V86.7999H283.85V93.1999H271.35V98.5999H284.85V105H263.45V74.8999Z",
    fill: "#F98F10"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5499 88.2998L81.5499 90.4998H81.4499V90.9998C81.4499 91.2998 81.4499 91.6998 81.4499 91.9998C81.4499 92.6998 81.4499 93.2998 81.4499 93.8998C81.3499 95.4998 80.2499 96.7998 78.7499 97.1998C78.1499 97.3998 77.5499 97.3998 76.7499 97.3998C75.0499 97.3998 73.1499 95.8998 73.1499 93.6998C73.1499 93.6998 73.1499 93.6998 73.1499 93.5998L73.0499 92.3998L67.7499 93.6998L64.1499 94.5998H64.0499C64.0499 94.7998 64.1499 95.5998 64.1499 95.5998C64.4499 97.4998 64.9499 98.9998 65.9499 100.4C67.3499 102.5 69.4499 103.9 72.1499 104.8C73.5499 105.2 75.1499 105.5 76.9499 105.5C77.1499 105.5 77.2499 105.5 77.4499 105.5C80.0499 105.5 82.2499 105.1 84.1499 104.1C88.0499 102.3 90.1499 99.1998 90.5499 95.0998C90.6499 93.7998 90.6499 92.4998 90.6499 91.1998C90.6499 90.6998 90.6499 90.0998 90.6499 89.5998V88.2998H90.5499Z",
    fill: "#F98F10"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.55 83.8C90.55 82.2 90.55 80.2 90.55 78.5V74.5H90.35H81.65H81.45V88.9L90.55 86.7V83.8Z",
    fill: "#F98F10"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9499 74.5H64.0499V93L72.9499 90.9V74.5Z",
    fill: "#F98F10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUseplace);
export default __webpack_public_path__ + "static/media/logo_useplace.4faaeef2fef6239bc0daf2263988f446.svg";
export { ForwardRef as ReactComponent };